import { sagas as retirementSagas } from '../features/Retirement/store/sagas'
import { sagas as settingSagas } from '../features/Setting/store/sagas'
import { sagas as productCommonSagas } from '../features/store/sagas'
export const sagas = [
  ...retirementSagas,
  ...settingSagas,
  ...productCommonSagas
]
